import React from 'react';
import BarChartIcon from '@mui/icons-material/BarChart';
import SettingsIcon from '@mui/icons-material/Settings';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import { matchPath } from 'react-router';
import AppsIcon from '@mui/icons-material/Apps';
import ReceiptIcon from '@mui/icons-material/Receipt';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import GroupsIcon from '@mui/icons-material/Groups';
import TimerIcon from '@mui/icons-material/Timer';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import LayersIcon from '@mui/icons-material/Layers';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { RightType } from '../models/Auth';

export interface PageRoute {
    headerTitle: string;
    title: string;
    path: string;
    icon?: React.ReactNode;
    requiresTables?: boolean;
    requiresWaitlist?: boolean;
    requiresGroupReservations?: boolean;
    requiredRights?: RightType[];
}

export const reservationsPage: PageRoute = {
    headerTitle: 'reservations',
    title: 'reservations',
    path: '/',
    icon: <MenuBookIcon />,
    requiredRights: [RightType.ADMIN, RightType.RESERVATIONS_ONLY, RightType.VIEW_ONLY, RightType.RESERVATIONS_AND_SETTINGS]
};

export const floorPlanDesignerPage: PageRoute = {
    headerTitle: 'floor_plan_designer',
    title: 'floor_plan_designer',
    path: '/floorplan-designer',
    icon: <AppsIcon />,
    requiredRights: [RightType.ADMIN, RightType.RESERVATIONS_AND_SETTINGS]
};

export const paymentsPage: PageRoute = {
    headerTitle: 'payments',
    title: 'payments',
    path: "/payments",
    icon: <ReceiptIcon />,
    requiredRights: [RightType.ADMIN, RightType.RESERVATIONS_AND_SETTINGS]
};

export const guestPage: PageRoute = {
    headerTitle: 'guests',
    title: 'guests',
    path: "/guests",
    icon: <PermContactCalendarIcon />,
    requiredRights: [RightType.ADMIN]
};

export const settingsPage: PageRoute = {
    headerTitle: 'settings',
    title: 'settings',
    path: "/settings",
    icon: <SettingsIcon />,
    requiredRights: [RightType.ADMIN, RightType.RESERVATIONS_ONLY, RightType.VIEW_ONLY, RightType.RESERVATIONS_AND_SETTINGS]
};

export const knowledgeBaseListPage: PageRoute = {
    headerTitle: 'knowledge_base',
    title: 'knowledge_base',
    path: "/knowledgebase",
    icon: <LightbulbIcon />,
    requiredRights: [RightType.ADMIN, RightType.RESERVATIONS_ONLY, RightType.VIEW_ONLY, RightType.RESERVATIONS_AND_SETTINGS]
};

export const knowledgeBaseArticlePage: PageRoute = {
    headerTitle: 'Knowledgebase',
    title: 'knowledge_base',
    path: "/knowledgebase/:article_id",
    icon: <LightbulbIcon />,
    requiredRights: [RightType.ADMIN, RightType.RESERVATIONS_ONLY, RightType.VIEW_ONLY, RightType.RESERVATIONS_AND_SETTINGS]
};

export const reservationTimeTablePage: PageRoute = {
    headerTitle: 'reservation_time_table',
    title: 'reservation_time_table',
    path: "/reservation-table",
    icon: <ListAltIcon />,
    requiresTables: true,
    requiredRights: [RightType.ADMIN, RightType.RESERVATIONS_ONLY, RightType.VIEW_ONLY, RightType.RESERVATIONS_AND_SETTINGS]
}

export const giftcardPage: PageRoute = {
    headerTitle: 'giftcards',
    title: 'giftcards',
    path: "/giftcards",
    icon: <CardGiftcardIcon />,
    requiredRights: [RightType.ADMIN, RightType.RESERVATIONS_AND_SETTINGS]
}

export const groupReservationPage: PageRoute = {
    headerTitle: 'group_reservation',
    title: 'group_reservation',
    path: "/group-reservation",
    icon: <GroupsIcon />,
    requiresGroupReservations: true,
    requiredRights: [RightType.ADMIN, RightType.RESERVATIONS_AND_SETTINGS]
}

export const groupReservationEditPage: PageRoute = {
    headerTitle: 'group_reservation_edit',
    title: 'group_reservation_edit',
    path: "/group-reservation/:request_public_id",
    icon: <GroupsIcon />,
    requiresGroupReservations: true,
    requiredRights: [RightType.ADMIN, RightType.RESERVATIONS_AND_SETTINGS]
}

export const reservationTablePlanPage: PageRoute = {
    headerTitle: 'table_planner',
    title: 'table_planner',
    path: "/table-planner",
    icon: <LayersIcon />,
    requiresTables: true,
    requiredRights: [RightType.ADMIN, RightType.RESERVATIONS_ONLY, RightType.VIEW_ONLY, RightType.RESERVATIONS_AND_SETTINGS]
}

export const waitlistPage: PageRoute = {
    headerTitle: 'waitlist',
    title: 'waitlist',
    path: "/waitlist",
    icon: <TimerIcon />,
    requiresWaitlist: true,
    requiredRights: [RightType.ADMIN, RightType.RESERVATIONS_ONLY, RightType.VIEW_ONLY, RightType.RESERVATIONS_AND_SETTINGS]
}

export const eventReservationsPage: PageRoute = {
    headerTitle: "events",
    title: "events",
    path: "/events/reservations",
    requiredRights: [RightType.ADMIN, RightType.RESERVATIONS_ONLY, RightType.VIEW_ONLY, RightType.RESERVATIONS_AND_SETTINGS]
}

export const loginPage: PageRoute = {
    headerTitle: 'Login',
    title: 'login',
    path: "/login",
};

export const forgotPasswordPage: PageRoute = {
    headerTitle: 'password_reset',
    title: 'password_reset',
    path: "/password-reset",
};

export const registrationPage: PageRoute = {
    headerTitle: 'registration',
    title: 'registration',
    path: "/registration",
};

export const printPage: PageRoute = {
    headerTitle: 'Print',
    title: 'Print',
    path: "/print",
}

export const statisticsPage: PageRoute = {
    icon: <BarChartIcon />,
    headerTitle: 'statistics',
    title: 'statistics',
    path: "/statistics",
    requiredRights: [RightType.ADMIN]
}

export const monthlySummary: PageRoute = {
    headerTitle: 'monthly_summary',
    title: 'monthly_summary',
    path: "/monthly-summary",
    requiredRights: [RightType.ADMIN]
}

export const pageRoutes = [
    reservationsPage,
    reservationTimeTablePage,
    reservationTablePlanPage,
    waitlistPage,
    groupReservationPage,
    statisticsPage,
    guestPage,
    paymentsPage,
    knowledgeBaseListPage,
    settingsPage,
];

export const routesWithTitleSync = [
    reservationsPage,
    paymentsPage,
    guestPage,
    settingsPage,
    knowledgeBaseListPage,
    loginPage,
    forgotPasswordPage,
    reservationTimeTablePage,
    floorPlanDesignerPage,
    printPage,
    groupReservationPage,
    groupReservationEditPage,
    giftcardPage,
    waitlistPage,
    statisticsPage,
    monthlySummary,
    reservationTablePlanPage,
    knowledgeBaseArticlePage,
    registrationPage,
];

export function findMatchingRoute(path: string, routes: string[]) {
    return routes.find(route => matchPath(route, path) != null);
}

export function apiRoute(route: string) {
    return process.env.REACT_APP_API_URL + route;
}

export function getRoutesForRestaurant(tableManagementOn: boolean, groupReservation: boolean, waitlist: boolean, userRightType: RightType) {
    let routes = pageRoutes;
    if(!tableManagementOn){
        routes = routes.filter(route => !route.requiresTables);
    }
    if(!waitlist){
        routes = routes.filter(route => !route.requiresWaitlist);
    }

    routes = routes.filter(route =>
        !route.requiredRights || route.requiredRights.includes(userRightType)
    );
    return routes;
}